const initialState = {
    messages: [],
    banners: []
}

export default function (state = initialState, action) {
    switch (action.type) {
        case 'MESSAGES':
            return { ...state, messages: action.payload } 
        case 'BANNERS':
            return { ...state, banners: action.payload }                             
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./reducers/messageReducer.js